module.exports = __webpack_public_path__ + "static/media/add-funds.d0aa5662.svg";